// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -973989318
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';
import { Document } from '../../models/contract/document';
import { Contact } from '../../models/contract/contact';
import { Payee } from '../../models/contract/payee';
import { User } from '../../models/security/user';

export class Contract {
  @Required()
  contractId: string;
  contractOwnerId: string;
  contractTypeId: number;
  holderTypeId: number;
  managementCompanyId: string;
  statusId: number;
  amendmentAddReplace: boolean;
  @StringLength(100)
  contactName: string;
  @StringLength(50)
  contactTitle: string;
  @StringLength(255)
  email: string;
  endDate: Date | string;
  @StringLength(50)
  fax: string;
  @Required()
  isAmendment: boolean;
  @Required()
  isBundledAnesthesiologist: boolean;
  @Required()
  isBundledFacility: boolean;
  @Required()
  isBundledProvider: boolean;
  @Required()
  isContractAutoRenewal: boolean;
  @StringLength(100)
  legalEntityName: string;
  @StringLength(256)
  name: string;
  @StringLength(10)
  npi: string;
  @StringLength(50)
  phone: string;
  startDate: Date | string;
  @StringLength(50)
  url: string;
  @StringLength(10)
  taxId: string;
  taxStatusId: number;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
  visiumContractId: number;
  @Required()
  enableAutoPrice: boolean;
  documents: Document[];
  contacts: Contact[];
  payees: Payee[];
  contractOwner: User;
}

export function initializeNewContract(): Contract {
  const instance = new Contract();
  instance.contractId = '00000000-0000-0000-0000-000000000000';
  instance.contractOwnerId = '00000000-0000-0000-0000-000000000000';
  instance.contractTypeId = null;
  instance.holderTypeId = null;
  instance.managementCompanyId = '00000000-0000-0000-0000-000000000000';
  instance.statusId = null;
  instance.amendmentAddReplace = false;
  instance.contactName = '';
  instance.contactTitle = '';
  instance.email = '';
  instance.endDate = null;
  instance.fax = '';
  instance.isAmendment = false;
  instance.isBundledAnesthesiologist = false;
  instance.isBundledFacility = false;
  instance.isBundledProvider = false;
  instance.isContractAutoRenewal = false;
  instance.legalEntityName = '';
  instance.name = '';
  instance.npi = '';
  instance.phone = '';
  instance.startDate = null;
  instance.url = '';
  instance.taxId = '00000000-0000-0000-0000-000000000000';
  instance.taxStatusId = null;
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.visiumContractId = null;
  instance.enableAutoPrice = false;
  instance.documents = null;
  instance.contacts = null;
  instance.payees = null;
  instance.contractOwner = null;
  return instance;
}
